<div class="flag-list d-flex flex-column" (click)="$event.stopPropagation();">
@for (flag of flags; track flag.id) {
  <mat-checkbox [style.background-color]="flag.color" class="p-2" (change)="onSelectedChange($event, flag.id)" [checked]="isSelected(flag.id)">{{ flag.name }}</mat-checkbox>
}
  <span class="text-muted m-3" *ngIf="!flags.length">No Lists available for this practice</span>
</div>
